import ManagerFactory from "../managers/ManagerFactory";

const manager = ManagerFactory.getManager();
function Form(props) {
  return manager.getSignupForm();
}

export default Form;
